import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE, FONT_SIZE } from '@app/src/ui';

interface CalendarProps {
  isDayMonth: boolean;
  isDayOtherMonth: boolean;
  current: boolean;
  selected: boolean;
  isDisabled: boolean;
  categoryName: string;
}

interface ArrowProps {
  isDisabled: boolean;
}

export const MonthDays = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto 25px;
  width: 280px;
  font-size: 13px;
  font-family: ${FONTS.ROBOTO};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 427px;
  }
`;

export const Day = styled.div`
  display: flex;
  height: 32px;
  width: 32px;
  margin: 4px 4px;
  color: ${COLORS.BLACK};
  font-family: ${FONTS.OPEN_SANS};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 25px;
  border: 1px solid ${COLORS.GRAY_PLACEHOLDER};
  font-size: ${FONT_SIZE.SHORT};
  line-height: 16px;
  font-weight: bold;
  ${(props: CalendarProps) => props.isDayMonth && css`
    border: none;
  `};
  ${(props: CalendarProps) => props.isDayOtherMonth && css`
    border: none;
  `};
  ${(props: CalendarProps) => props.current && css`
    border: none;
    background-color: ${COLORS.GRAY_LIGHT};
    pointer-events: none;
  `};
  ${(props: CalendarProps) => props.selected && css`
    border: none;
    background: ${COLORS.BLACK_BOLD};
    color: #FFFFFF;
  `};
  ${(props: CalendarProps) => props.isDisabled && css`
    opacity: .3;
    pointer-events: none;
    border-radius: 22px;
  `};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 49px;
    width: 49px;
    font-size: 14px;
    margin: 6px 6px;
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 21px;
`;

export const Month = styled.span`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 16px;
  color: ${COLORS.BLACK_BOLD};
  padding: 0 56px;
`;

export const PrevArrow = styled.div`
  cursor: pointer;
  ${(props: ArrowProps) => props.isDisabled && css`
    pointer-events: none;
    opacity: .3;
  `};
`;

export const NextArrow = styled.div`
  transform: scaleX(-1);
  cursor: pointer;
  ${(props: ArrowProps) => props.isDisabled && css`
    pointer-events: none;
    opacity: .3;
  `};
`;
